// Contact.jsx
import React, { useState } from "react";
import Navbar from "../Components/NavBar";
import "../css/LandingPage.css";

const INTEREST_OPTIONS = [
  { value: "Buying", label: "Buying a home" },
  { value: "Selling", label: "Selling a home" },
  { value: "Both", label: "Buying & Selling" },
  { value: "Relocation", label: "Relocation" },
  { value: "General", label: "General question" },
];

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "Buying",
    message: "",
    fax: "", // honeypot (must exist because you reference it)
    consent: false,
  });

  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  async function onSubmit(e) {
    e.preventDefault();

    // honeypot check
    if (form.fax) return;

    setStatus({ state: "loading", msg: "" });

    if (!form.consent) {
      setStatus({ state: "error", msg: "Please check the consent box before sending your message." });
      return;
    }


    try {
      const payload = {
        formType: "contact",
        name: form.name.trim(),
        email: form.email.trim(),
        phone: (form.phone || "").trim(),
        interest: form.interest,
        message: form.message.trim(),
        consent: form.consent,
        fax: form.fax,
      };

      const r = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!r.ok) {
        const data = await r.json().catch(() => ({}));
        throw new Error(data.error || `Request failed (${r.status})`);
      }

      setStatus({ state: "success", msg: "Message sent! Brooke will reach out soon." });
      setForm({ name: "", email: "", phone: "", interest: "Buying", message: "", fax: "", consent: false });
    } catch (err) {
      console.error(err);
      setStatus({ state: "error", msg: "Something went wrong. Please try again." });
    }
  }

  // Contact.jsx (render section only)

return (
  <div className="interior-page-contact" id="contact">
    <Navbar variant="contact" />

    {/* New hero */}
    <header className="contact-hero">
      <div className="contact-hero-bg" />
      <div className="interior-inner contact-hero-inner">
        <div className="contact-hero-card contact-hero-card--primary">
          <div className="contact-hero-eyebrow">
          </div>

          <h2 className="contact-hero-title">How Can I Help?</h2>
          <p>{""}</p>
        </div>
      </div>
    </header>

    <main className="interior-inner contact-main">
      <div className="contact-layout">
        {/* Left: form */}
        <div className="ui-card contact-card">
          <form onSubmit={onSubmit} className="contact-form" noValidate>
            {/* honeypot */}
            <input
              type="text"
              name="fax"
              value={form.fax}
              onChange={onChange}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              className="hp"
            />

            <div className="form-grid">
              <div className="field">
                <label className="label" htmlFor="name">Name:</label>
                <input
                  id="name"
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  placeholder="First / Last"
                  required
                  className="control"
                />
              </div>

              <div className="field">
                <label className="label" htmlFor="email">Email:</label>
                <input
                  id="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="someone@example.com"
                  type="email"
                  required
                  className="control"
                />
              </div>

              <div className="field">
                <label className="label" htmlFor="phone">Phone: (optional)</label>
                <input
                  id="phone"
                  name="phone"
                  value={form.phone}
                  onChange={onChange}
                  placeholder="(555) 555-5555"
                  className="control"
                />
              </div>

              <div className="field">
                <label className="label" htmlFor="interest">I’m interested in:</label>
                <select
                  id="interest"
                  name="interest"
                  value={form.interest}
                  onChange={onChange}
                  className="control select"
                >
                  {INTEREST_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field span-2">
                <label className="label" htmlFor="message">How can I help?</label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  placeholder="Tell me what you need help with…"
                  rows={6}
                  required
                  className="control textarea"
                />
                <div className="help">
                  Include a timeline (if you have one) and any neighborhoods or must-haves.
                </div>
              </div>

              <div className="field span-2">
                <label className="consent">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={form.consent}
                    onChange={onChange}
                    required
                  />
                  <span>
                    I agree to be contacted by Brooke via email (and phone if provided) about my inquiry.
                    I understand I can unsubscribe at any time.
                  </span>
                </label>
              </div>

              <div className="field span-2">
                <button
                  className="btn primary contact-submit"
                  type="submit"
                  disabled={status.state === "loading" || !form.consent}
                >
                  {status.state === "loading" ? "Sending..." : "Send Message"}
                </button>

                {status.state !== "idle" && (
                  <div
                    className={`form-banner ${status.state === "success" ? "success" : "error"}`}
                    role="status"
                    aria-live="polite"
                  >
                    {status.msg}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
);
}
